export default __webpack_public_path__ + "static/media/on_delivery_time1.9c82886a.png";